// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;As we had heard, so have we seen<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in the city of the Lord of hosts, the city of our God:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;God has established her for ever.<br> </p> </div></div>";
// Exports
module.exports = code;